import { connect } from 'react-redux';
import DashboardCardContent from 'components/dashboard/DashboardCardContent';
import { getLiveParams } from "selectors/liveParams";

const LIVE_PARAMS = 'all';

// windTurbine can be momentarily undefined during navigation between two
// turbines' detail pages - see components/dashboard/CardHeader.js's guard
// for the crash this caused. mapStateToProps runs on every store update.
const mapStateToProps = (state, ownProps) => {
  const windTurbineId = ownProps.windTurbine && ownProps.windTurbine.id;
  return {
    liveProps: getLiveParams(state, windTurbineId, LIVE_PARAMS),
    turbineState: state.turbineState[windTurbineId],
  };
};

export default connect(mapStateToProps)(DashboardCardContent);
